var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 3.3c.4 0 .8.3.9.8v11.6c0 .4-.3.8-.8.9H3.4c-.4 0-.8-.3-.9-.8V7.6h2.2c1 0 1.9-.8 2-1.8V3.3h5zm3 9.2c.1 0 .3.1.4.2l.1.1 1 1.3c.2-.1.3-.1.5-.1.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3s-1.3-.6-1.3-1.3V15l-.9-1.3h-.9v-1.1h1.1zm-7.2-.1H3.7v1.5h3.8v-1.5zM17 8.8c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3-.5 0-.9-.3-1.1-.6l-.1-.1h-2.3V9.6h2.3c.3-.5.7-.8 1.2-.8zm-5.6.7H3.7V11h7.7V9.5zm5.2-6.1c.7 0 1.3.6 1.3 1.3S17.3 6 16.6 6h-.4l-1.1 1.5c-.1.1-.2.2-.4.2h-1.3V6.5h.9l1-1.3c-.1-.1-.1-.3-.1-.5.1-.8.7-1.3 1.4-1.3zm-11.1 0v2.2c0 .4-.3.8-.7.8H2.5l3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.81ce6d4c.svg";
export { ForwardRef as ReactComponent };